/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-html-link-for-pages */
/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Row, Tooltip } from 'antd'
import { useTranslation } from 'contexts/Localization'
import styled from 'styled-components'
import { Box, Flex, Link } from 'widgets'
import useIsMobile from 'hooks/useIsMobile'
import { useEffect, useState } from 'react'
import { getContactContentChat } from 'hooks/getContactContentChat'

const FooterWrapper = styled.footer<{ txtCommingSoon: string }>`
  position: relative;
  z-index: 100;
  padding: 32px 0 28px 0;
  background: #05050f;
  color: #f5f6fa;
  padding-bottom: 100px;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 4rem 0 100px 0;
  }

  @media (min-width: 1024px) {
    padding-bottom: 3rem;
  }

  ul {
    list-style-type: none;
    li {
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;

        ${({ theme }) => theme.mediaQueries.sm} {
          margin-bottom: 15px;
        }
      }
    }
  }

  h3 {
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    color: #f5f6fa;
    margin-bottom: 30px;
  }

  .footer-content {
    justify-content: space-between;
    flex-direction: column;

    ${({ theme }) => theme.mediaQueries.md} {
      flex-direction: row;
    }
  }

  .b-left {
    margin-bottom: 29px;

    ${({ theme }) => theme.mediaQueries.lg} {
      margin-bottom: 2.5rem;
    }

    .logo {
      margin-bottom: 17px;
      justify-content: center;

      ${({ theme }) => theme.mediaQueries.sm} {
        margin-bottom: 15px;
      }

      img:first-child {
        margin-right: 4.21px;

        ${({ theme }) => theme.mediaQueries.sm} {
          margin-right: 20px;
        }
      }

      img {
        &:first-child {
          width: 38.39px;
        }

        &:nth-child(2) {
          width: 68.4px;
          margin-top: 9px;
        }

        ${({ theme }) => theme.mediaQueries.sm} {
          &:first-child {
            width: auto;
          }

          &:nth-child(2) {
            width: auto;
            margin-top: 0;
          }
        }
      }
    }

    p {
      text-align: center;
    }

    .description {
      p {
        margin-bottom: 10px;

        ${({ theme }) => theme.mediaQueries.lg} {
          margin-bottom: 10px;
        }
      }
    }

    ${({ theme }) => theme.mediaQueries.md} {
      margin-bottom: 0;

      .logo {
        justify-content: flex-start;
      }

      p {
        text-align: left;
      }
    }
  }

  .b-right {
    width: 100%;

    .ant-col {
      padding-top: 29px;
      padding-bottom: 5px;
      border-top: 0.2px solid #ffffff;
      max-width: calc(100% - 40px);
      margin-left: auto;
      margin-right: auto;

      ${({ theme }) => theme.mediaQueries.sm} {
        padding-top: 0;
        padding-bottom: 0;
        border-top: none;
        max-width: unset;
      }
    }

    h3 {
      text-align: center;
    }

    ul {
      li {
        text-align: center;
      }
    }
    ${({ theme }) => theme.mediaQueries.sm} {
      h3 {
        text-align: left;
      }

      ul {
        li {
          text-align: left;
        }
      }
    }

    ${({ theme }) => theme.mediaQueries.md} {
      width: 70%;
    }
  }

  .social-network {
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: center;
    align-items: center;
    max-width: 90%;
    margin: auto;

    ${({ theme }) => theme.mediaQueries.xs} {
      max-width: 60%;
    }

    ${({ theme }) => theme.mediaQueries.sm} {
      max-width: 100%;
    }
  }

  .copyright {
    padding-top: 2.5rem;
    text-align: center;
  }

  .comming-soon {
    position: relative;
    cursor: pointer;
    &:after {
      content: '${({ txtCommingSoon }) => txtCommingSoon}';
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      background-color: #fff;
      z-index: 50;
      color: black;
      padding: 5px 10px;
      border-radius: 10px;
      transition: all 0.35s ease-in-out;
      opacity: 0;
      padding-bottom: 7px;
    }

    &:hover {
      &:after {
        opacity: 1;
      }
    }
  }

  .social-network {
    .comming-soon {
      &:after {
        left: 50%;
        right: auto;
        transform: translate(-50%, -50%);
      }
    }
  }
`

export const defaultSocialData = [
  {
    link: 'https://docs.soei.social',
    type: 'Docs',
    icon: 'https://gateway.asdi.foundation/icons/soei.png',
  },
  {
    link: 'https://x.com/soei_io',
    type: 'Twitter',
    icon: 'https://gateway.asdi.foundation/icons/x.png',
  },
  {
    link: 'https://t.me/soei_ann',
    type: 'TelegramChannel',
    icon: 'https://gateway.asdi.foundation/icons/tele_channel.png',
  },
  {
    link: 'https://t.me/soei_io',
    type: 'TelegramGroup',
    icon: 'https://gateway.asdi.foundation/icons/telegram.png',
  },
  {
    link: 'https://www.linkedin.com/company/soeiio',
    type: 'Linkedin',
    icon: 'https://gateway.asdi.foundation/icons/linkedin.png',
  },
  {
    link: 'https://youtube.com/@soei_io',
    type: 'Youtube',
    icon: 'https://gateway.asdi.foundation/icons/youtube.png',
  },
  {
    link: 'https://www.instagram.com/soei_io/',
    type: 'Instagram',
    icon: 'https://gateway.asdi.foundation/icons/instagram.png',
  },
  {
    link: 'https://mirror.xyz/0x1A57DB0498E7121b683f75A7f7162A7C347bf04B',
    type: 'Mirror',
    icon: 'https://gateway.asdi.foundation/icons/mirror.png',
  },
  {
    link: 'https://soei.social',
    type: 'Website',
    icon: 'https://gateway.asdi.foundation/icons/soei.png',
  },
  {
    link: 'https://discord.com/invite/Cn6CKcUYYp',
    type: 'Discord',
    icon: 'https://gateway.asdi.foundation/icons/discord.png',
  },
]

const mobileWith = 576

interface SocialMediaItem {
  link: string
  type: string
  icon: string
}

interface SocialMediaLinks {
  [key: string]: string // type as key, link as value
}

const Footer = () => {
  const { t } = useTranslation()
  const isMobile = useIsMobile(mobileWith)
  const [socialLinks, setSocialLinks] = useState<SocialMediaLinks>({})

  const transformSocialData = (data: SocialMediaItem[]) => {
    return data.reduce(
      (acc, item) => ({
        ...acc,
        [item.type]: item.link,
      }),
      {},
    )
  }

  useEffect(() => {
    const getData = async () => {
      const data = await getContactContentChat()
      setSocialLinks(transformSocialData(data || defaultSocialData))
    }

    getData()
  }, [])

  return (
    <FooterWrapper txtCommingSoon={t('Sắp có')}>
      <div className="container">
        <Flex className="footer-content">
          <div className="b-left">
            <Flex className="logo">
              <img style={{ width: '160px' }} src="/images/white-logo.png" alt="" />
            </Flex>
            <div
              className="description"
              dangerouslySetInnerHTML={{
                __html: t(
                  '<p>Một nền tảng giao dịch NFT và số hóa<br/>tài sản thực;</p><p>Mua, bán và sưu tầm NFT;</p><p>Chuyển giao quyền sở hữu tài sản thực.</p>',
                ),
              }}
            />
          </div>
          <div className="b-right">
            <Row gutter={[24, 24]}>
              <Col lg={6} sm={12} span={24}>
                <Link href="https://soei.social/about-us" external>
                  <h3 className="pointer">{t('Công ty')}</h3>
                </Link>
                <Row>
                  <Col span={12} sm={24} lg={24} style={{ paddingTop: 0, borderTop: 'none' }}>
                    <ul>
                      <li>
                        <Link href="https://soei.social/about-us" external>
                          {t('Về chúng tôi')}
                        </Link>
                      </li>
                      <li>
                        <Link href="https://soei.social/recruitment" external>
                          {t('Cơ hội nghề nghiệp - Footer')}
                        </Link>
                      </li>
                      <li>
                        <Link href="https://soei.social/policy?o=general" external>
                          {t('Điều khoản')}
                        </Link>
                      </li>
                      <li>
                        <Link href="https://soei.social/policy?o=privacy" external>
                          {t('Riêng tư')}
                        </Link>
                      </li>
                      <li>
                        <Link href="https://soei.social/policy?o=risk" external>
                          {t('Khuyến cáo rủi ro')}
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  {isMobile && (
                    <Col span={12} lg={24} style={{ paddingTop: 0, borderTop: 'none' }}>
                      <ul>
                        <li>
                          <Link href="https://soei.social/contact" external>
                            {t('Liên hệ hợp tác')}{' '}
                          </Link>
                        </li>
                        <li className="comming-soon">{t('Chuỗi khối')}</li>

                        <li>
                          <Link href="https://soei.social/news" external>
                            {t('Tin tức')}
                          </Link>
                        </li>
                      </ul>
                    </Col>
                  )}
                </Row>
              </Col>
              {!isMobile && (
                <Col lg={6} sm={12} span={24}>
                  <h3 style={{ opacity: 0 }}>{t('Liên hệ')}</h3>
                  <ul>
                    <li>
                      <Link href="https://soei.social/contact" external>
                        {t('Liên hệ hợp tác')}{' '}
                      </Link>
                    </li>
                    <li className="comming-soon">{t('Chuỗi khối')}</li>

                    <li>
                      <Link href="https://soei.social/news" external>
                        {t('Tin tức')}
                      </Link>
                    </li>
                  </ul>
                </Col>
              )}

              <Col lg={6} sm={12} span={24}>
                <h3>{t('Cộng đồng')}</h3>
                <Flex className="social-network">
                  <Tooltip
                    placement="bottom"
                    color="#ffffff"
                    title={
                      <p className="tooltip-content-dark">
                        Telegram
                        <br /> Channel
                      </p>
                    }
                  >
                    <a className="tele-group" href={socialLinks.TelegramChannel} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/telegram.svg" alt="" />
                    </a>
                  </Tooltip>

                  <Tooltip
                    placement="bottom"
                    color="#ffffff"
                    title={
                      <p className="tooltip-content-dark">
                        Telegram <br /> Group
                      </p>
                    }
                  >
                    <a className="tele-channel" href={socialLinks.TelegramGroup} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/telegram.svg" alt="" />
                    </a>
                  </Tooltip>

                  <Tooltip placement="bottom" color="#ffffff" title={<p className="tooltip-content-dark">Twitter</p>}>
                    <a href={socialLinks.Twitter} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/twitter.svg" alt="" />
                    </a>
                  </Tooltip>

                  <Tooltip placement="bottom" color="#ffffff" title={<p className="tooltip-content-dark">LinkedIn</p>}>
                    <a href={socialLinks.Linkedin} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/linkedin.png" alt="" />
                    </a>
                  </Tooltip>

                  <Tooltip placement="bottom" color="#ffffff" title={<p className="tooltip-content-dark">Discord</p>}>
                    <a href={socialLinks.Discord} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/discord.png" alt="" />
                    </a>
                  </Tooltip>

                  <Tooltip placement="bottom" color="#ffffff" title={<p className="tooltip-content-dark">Youtube</p>}>
                    <a href={socialLinks.Youtube} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/youtube.png" alt="" />
                    </a>
                  </Tooltip>

                  <Tooltip placement="bottom" color="#ffffff" title={<p className="tooltip-content-dark">Instagram</p>}>
                    <a href={socialLinks.Instagram} target="_blank" rel="noreferrer">
                      <img src="/images/social-network/instagram.png" alt="" />
                    </a>
                  </Tooltip>
                </Flex>
              </Col>
            </Row>
          </div>
        </Flex>
        <div className="copyright">
          <p>&copy; {t('2023 SOEI Foundation. All rights reserved.')}</p>
        </div>
      </div>
    </FooterWrapper>
  )
}

export default Footer
